exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input {\r\n     text-align: left; \r\n     border: none;\r\n     width: 100%;\r\n     background: transparent;\r\n} \r\n\r\ninput:focus {\r\n    outline: none;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/components/Grid/textEditor.component.css
// module id = 448
// module chunks = 1